import { NgModule } from '@angular/core';
import { AngularFireAuthGuard, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';
import { RouterModule } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { AppDetailComponent } from './pages/app-detail/app-detail.component';
import { ClinicsComponent } from './pages/clinics/clinics.component';
import { ClinicSpecialistsComponent } from './pages/clinics/specialists/specialists.component';
import { ClinicUsersComponent } from './pages/clinics/users/users.component';
import { ClinicVisitsComponent } from './pages/clinics/visits/visits.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { SpecialistsComponent } from './pages/specialists/specialists.component';
import { UsersComponent } from './pages/users/users.component';
import { VisitsComponent } from './pages/visits/visits.component';
import { ClinicResolver } from './resolvers/clinic.resolver';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          component: AppLayoutComponent,
          canActivate: [AngularFireAuthGuard],
          data: { authGuardPipe: redirectUnauthorizedToLogin },
          children: [
            {
              path: '',
              component: HomeComponent,
            },
            { path: 'app', component: AppDetailComponent },

            { path: 'clinics', component: ClinicsComponent },
            {
              path: 'clinics/:clinicSlug/specialists',
              component: ClinicSpecialistsComponent,
              resolve: {
                clinic: ClinicResolver,
              },
            },
            {
              path: 'clinics/:clinicSlug/users',
              component: ClinicUsersComponent,
              resolve: {
                clinic: ClinicResolver,
              },
            },
            {
              path: 'clinics/:clinicSlug/visits',
              component: ClinicVisitsComponent,
              resolve: {
                clinic: ClinicResolver,
              },
            },
            { path: 'specialists', component: SpecialistsComponent },
            { path: 'users', component: UsersComponent },
            { path: 'visits', component: VisitsComponent },
          ],
        },

        {
          path: 'login',
          component: LoginComponent,
        },

        { path: 'notfound', component: NotfoundComponent },

        { path: '**', redirectTo: '/notfound' },
      ],
      {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'reload',
      },
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
